import { Button, Card, Skeleton } from "@dawa/ui";
import { List } from "lucide-react";
import { CopyButton } from "./CopyButton";

function renderOutline(md: string) {
  const lines = md.split(/\r?\n/).filter((line) => line.trim().length > 0);
  if (lines.length === 0) return null;

  const items = lines.map((line) => ({
    level: (line.match(/^#+/) || [""])[0].length,
    bullet: /^\s*[-*+]/.test(line),
    text: line.replace(/^\s*[-*+]\s*/, "").replace(/^#+\s*/, ""),
  }));

  const listishCount = items.filter((item) => item.bullet || item.level > 0).length;
  const isMostlyList = listishCount >= Math.max(1, Math.floor(items.length * 0.6));

  if (isMostlyList) {
    return (
      <ul className="space-y-1 pl-6 list-disc">
        {items.map((item, index) => (
          <li
            key={index}
            style={item.level > 1 ? { marginLeft: `${(item.level - 1) * 8}px` } : undefined}
          >
            {item.text}
          </li>
        ))}
      </ul>
    );
  }

  return <div className="whitespace-pre-wrap leading-relaxed">{md}</div>;
}

export function OutlineCard({
  outline,
  loading = false,
  onGenerate,
}: {
  outline: string;
  loading?: boolean;
  onGenerate?: () => void;
}) {
  return (
    <Card className="space-y-3 p-4">
      <div className="flex items-center justify-between">
        <h2 className="flex items-center gap-2 text-base font-semibold">
          <List className="h-4 w-4 text-muted" /> Plan
        </h2>
        <CopyButton text={outline} />
      </div>
      {loading ? (
        <Skeleton lines={6} />
      ) : outline ? (
        renderOutline(outline)
      ) : (
        <div className="flex flex-col items-center justify-center gap-3 py-8 text-center">
          <div className="text-sm text-muted">Aucun plan généré pour l’instant</div>
          {onGenerate && (
            <Button type="button" aria-label="Générer le plan" onClick={onGenerate}>
              Générer le plan
            </Button>
          )}
        </div>
      )}
    </Card>
  );
}
